<template>
  <div :class="$style.container">
    <div :class="$style.nav">
      <template v-for="(item, index) in navList">
        <div
          :class="{
            [$style.nav_item]: true,
            [$style.nav_active]: navIndex === index,
          }"
          :key="index"
          @click="() => jumpPage(item.link, index)"
        >
          <img
            :class="$style.icon_img"
            :src="navIndex === index ? item.activeIcon : item.icon"
            alt="icon"
          />
        </div>
      </template>
    </div>

    <div :class="$style.sub_nav">
      <template v-for="(item, index) in navList[navIndex].children">
        <div
          :class="{
            [$style.sub_nav_item]: true,
            [$style.sub_nav_active]: subNavIndex === index,
          }"
          :key="index"
          @click="() => jumpPage(item.link, index, true)"
        >
          {{ item.name }}
        </div>
      </template>
    </div>
  </div>
</template>

<script>
const mapRouteToIndex = {
  "/user": [0, 0],
  "/user/my-domain": [1, 0],
  "/user/analysis": [1, 0],
  "/user/dns": [1, 0],
  "/user/do-detail": [1, 0],
  "/user/my-template": [1, 1],
  "/user/domain-out": [1, 2],
  "/user/domain-enter": [1, 3],
  "/user/domain-push": [1, 4],
  "/user/domain-order": [1, 5],
  "/user/order-detail": [1, 5],

  "/user/account": [2, 0],
  "/user/fund": [2, 1],
  "/user/freeze": [2, 2],
  "/user/receipt": [2, 3],
  "/user/recharge": [2, 0],
  "/user/withDrawal": [2, 0],

  "/user/detail": [3, 0],
  "/user/safe": [3, 1],
  "/user/safe-name": [3, 1],
  "/user/safe-pwd": [3, 1],
  "/user/email-add": [3, 1],
  "/user/email-update": [3, 1],
  "/user/safe-phone": [3, 1],
  "/user/certification": [3, 2],
  "/user/certify-email": [3, 2],
  "/user/certify-user": [3, 2],
  "/user/certify-company": [3, 2],
  "/user/mail": [3, 3],
  "/user/log": [3, 4],
};

export default {
  name: "UserNav",
  data() {
    return {
      navIndex: 0,
      subNavIndex: 0,
      navList: [
        {
          name: "控制台",
          icon: require("@assets/image/ctrl.png"),
          activeIcon: require("@assets/image/ctrl_white.png"),
          link: "/user",
          children: [
            {
              name: "控制台",
              link: "/user",
            },
          ],
        },
        {
          name: "域名管理",
          icon: require("@assets/image/manage.png"),
          activeIcon: require("@assets/image/manage_white.png"),
          link: "/user/my-domain",
          children: [
            {
              name: "我的域名",
              link: "/user/my-domain",
            },
            {
              name: "我的模板",
              link: "/user/my-template",
            },
            {
              name: "域名转出",
              link: "/user/domain-out",
            },
            {
              name: "域名转入",
              link: "/user/domain-enter",
            },
            {
              name: "域名PUSH",
              link: "/user/domain-push",
            },
            {
              name: "域名订单",
              link: "/user/domain-order",
            },
          ],
        },
        {
          name: "资金管理",
          icon: require("@assets/image/fund.png"),
          activeIcon: require("@assets/image/fund_white.png"),
          link: "/user/account",
          children: [
            {
              name: "账户信息",
              link: "/user/account",
              index: [2, 0],
            },
            {
              name: "资金明细",
              link: "/user/fund",
              index: [2, 1],
            },
            // {
            //   name: "冻结明细",
            //   link: "/user/freeze",
            //   index: [2, 2],
            // },
            // {
            //   name: "发票管理",
            //   link: "/user/receipt",
            //   index: [2, 3],
            // },
          ],
        },
        {
          name: "账户管理",
          icon: require("@assets/image/account.png"),
          activeIcon: require("@assets/image/account_white.png"),
          link: "/user/detail",
          children: [
            {
              name: "个人资料",
              link: "/user/detail",
            },
            {
              name: "安全中心",
              link: "/user/safe",
            },
            {
              name: "我的认证",
              link: "/user/certification",
            },
            {
              name: "站内信",
              link: "/user/mail",
            },
            {
              name: "登录日志",
              link: "/user/log",
            },
          ],
        },
      ],
    };
  },
  computed: {},
  watch: {
    $route(val) {
      this.setNavIndex();
    },
  },
  methods: {
    jumpPage(link, index, isSub = false) {

      if (isSub) {
        this.subNavIndex = index;
      } else {
        this.subNavIndex = 0;
        this.navIndex = index;
      }

      if (!link) return;
      this.$router.push(link);
      document.querySelector("#user-page").scrollIntoView();
    },
    setNavIndex() {
      // 页面首次进入，强制刷新时保持导航跟随路由高亮
      const path = this.$route.path;
      const index = mapRouteToIndex[path] || [0, 0];
      this.navIndex = index[0];
      this.subNavIndex = index[1];
    },
  },
  mounted() {
    this.setNavIndex();
  },
};
</script>

<style lang='scss' module scoped>
.container {
  height: 100%;
  width: rem(300);

  display: flex;
  flex-wrap: nowrap;
  align-items: flex-start;
  background: $white;
  box-shadow: 10px 0 20px -10px rgba(2, 2, 2, 0.05);

  .nav {
    width: rem(80);
    min-width: 60px;
    height: 100%;

    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;

    border-right: $border-1;

    .nav_item {
      width: 100%;
      height: rem(60);
      min-height: 45px;
      @include flex();
      background: $white;
      cursor: pointer;

      &:first-child {
        margin-top: 20px;
      }
      &.nav_active {
        background: $theme-color;
      }

      .icon_img {
        width: rem(24);
      }
    }
  }

  .sub_nav {
    flex: 1;
    padding-top: 20px;

    .sub_nav_item {
      height: rem(60);
      min-height: 45px;
      padding-left: rem(50);
      font-size: 14px;
      color: #333;
      line-height: rem(60);
      // line-height: max(rem(60), 45px);
      text-align: left;
      background: $white;
      border-right: 3px solid transparent;
      cursor: pointer;

      &.sub_nav_active {
        background: #ffeae5;
        border-color: $theme-color;
      }
    }
  }
}
</style>